module.exports = __webpack_public_path__ + "static/media/vehicle8.6f314889.svg";